import React from "react";
import Chats from "./Chats";
import Navbar from "../general/Navbar";
import Search from "../general/Search";
import Navigation from "./Navigation";

export default function Sidebar({ groupHandler }) {
  return (
    <div className="sidebar">
      <Navbar />
      <Search />
      <Chats />
      <Navigation groupHandler={groupHandler} />
    </div>
  );
}
